import { MutableRefObject, useEffect } from 'react'

import type { FrameOptions } from 'amazon-quicksight-embedding-sdk'

import { useEmbeddingContext } from './useEmbeddingContext'

type UseEmbedDashboardProps = {
  containerRef: MutableRefObject<any>
  setIsLoading: (isLoading: boolean) => void
  url: string
}

export function useEmbedDashboard({ containerRef, setIsLoading, url }: UseEmbedDashboardProps) {
  const embeddingContext = useEmbeddingContext()

  useEffect(() => {
    if (!embeddingContext || !url) return

    const frameOptions: FrameOptions = {
      url,
      container: containerRef.current,
      height: '100%',
      width: '100%',
      resizeHeightOnSizeChangedEvent: true,
      onChange: (changeEvent) => {
        switch (changeEvent.eventName) {
          case 'FRAME_LOADED': {
            setIsLoading(false)
            break
          }
        }
      },
    }

    embeddingContext.embedDashboard(frameOptions)

    return () => {
      if (containerRef.current?.children?.length) {
        containerRef.current?.children[0]?.remove()
      }
    }
  }, [containerRef, embeddingContext, setIsLoading, url])
}
